import type { CreateOrderWithItemsDto, StockValidationResultDto } from '../../orders/models';

export interface ActivePaymentProviderDto {
  provider?: string;
  minimumAmountForInstallments?: number;
}

export interface IdentificationDto {
  type?: string;
  number?: string;
}

export interface InstallmentOptionDto {
  quotas?: number;
  interestRate?: number;
  monthlyPayment?: number;
  total?: number;
  isNoInterest?: boolean;
}

export interface PayerDto {
  email?: string;
  identification?: IdentificationDto;
}

export interface PaymentRequestDto {
  amount?: number;
  token?: string;
  paymentMethodId?: string;
  installments?: number;
  issuerId?: string;
  payer?: PayerDto;
}

export interface PaymentResultDto {
  resultado?: string;
  status?: string;
  paymentId?: number;
}

export interface UpdatePaymentSettingsDto {
  provider?: string;
  minimumAmountForInstallments?: number;
}

export interface MercadoPagoOrderRequestDto {
  pago?: MercadoPagoRequestDto;
  order?: CreateOrderWithItemsDto;
}

export interface MercadoPagoRequestDto {
  token?: string;
  paymentMethodId?: string;
  issuerId?: string;
  installments?: number;
  amount?: number;
  interestCharge?: number;
  payer?: PayerDto;
}

export interface PagoResultadoDto {
  resultado?: string;
  status?: string;
  paymentId?: number;
}

export interface PaymentOrderResultDto {
  paymentStatus?: string;
  paymentTransactionId?: number;
  orderId?: number;
  message?: string;
  stockIssues?: StockValidationResultDto[];
  noStockInAnyDeposit?: boolean;
}

export interface StartAllariaCheckoutResultDto {
  orderId: number;
  clientPurchaseId?: string;
  redirectUrl?: string;
}

export interface AllariaReturnResultDto {
  paymentStatus?: string;
  orderId?: number;
  clientPurchaseId?: string;
  message?: string;
}
